import React from 'react';
import { List, ListItem, ListSubheader, Paper } from '@material-ui/core'; 
import useStyles from './VerticalTabsStyle';

interface Tab {
  label: string;
}

interface VerticalTabsProps {
  title: string;
  tabs: Tab[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

const VerticalTabs: React.FC<VerticalTabsProps> = ({ title, tabs, activeTab, onTabChange }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <List
        component="nav"
        subheader={
          <ListSubheader component="div" className={classes.title}>
            {title}
          </ListSubheader>
        }
      >
        {tabs.map((tab, index) => (
          <ListItem
            key={index}
            button
            selected={activeTab === index}
            onClick={() => onTabChange(index)}
            className={classes.tabButton}
          >
            {tab.label}
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default VerticalTabs;